var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.6667H2C1.72667 14.6667 1.5 14.4401 1.5 14.1667C1.5 13.8934 1.72667 13.6667 2 13.6667H14C14.2733 13.6667 14.5 13.8934 14.5 14.1667C14.5 14.4401 14.2733 14.6667 14 14.6667Z",
    fill: "url(#paint0_linear_1612_352)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6804 2.31994C11.387 1.02661 10.1204 0.993275 8.79371 2.31994L7.98704 3.12661C7.92037 3.19328 7.89371 3.29994 7.92038 3.39328C8.42704 5.15994 9.84037 6.57328 11.607 7.07994C11.6337 7.08661 11.6604 7.09328 11.687 7.09328C11.7604 7.09328 11.827 7.06661 11.8804 7.01328L12.6804 6.20661C13.3404 5.55328 13.6604 4.91994 13.6604 4.27994C13.667 3.61994 13.347 2.97994 12.6804 2.31994Z",
    fill: "url(#paint1_linear_1612_352)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4066 7.68678C10.2132 7.59345 10.0266 7.50011 9.84655 7.39345C9.69989 7.30678 9.55989 7.21345 9.41989 7.11345C9.30655 7.04011 9.17322 6.93345 9.04655 6.82678C9.03322 6.82011 8.98655 6.78011 8.93322 6.72678C8.71322 6.54011 8.46655 6.30011 8.24655 6.03345C8.22655 6.02011 8.19322 5.97345 8.14655 5.91345C8.07989 5.83345 7.96655 5.70011 7.86655 5.54678C7.78655 5.44678 7.69322 5.30011 7.60655 5.15345C7.49989 4.97345 7.40655 4.79345 7.31322 4.60678C7.19085 4.34455 6.84668 4.26666 6.64206 4.47127L2.89322 8.22011C2.80655 8.30678 2.72655 8.47345 2.70655 8.58678L2.34655 11.1401C2.27989 11.5934 2.40655 12.0201 2.68655 12.3068C2.92655 12.5401 3.25989 12.6668 3.61989 12.6668C3.69989 12.6668 3.77989 12.6601 3.85989 12.6468L6.41989 12.2868C6.53989 12.2668 6.70655 12.1868 6.78655 12.1001L10.5416 8.34509C10.7421 8.14456 10.6668 7.79954 10.4066 7.68678Z",
    fill: "url(#paint2_linear_1612_352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_352",
    x1: 1.54643,
    y1: 14.1667,
    x2: 14.4839,
    y2: 13.6759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1612_352",
    x1: 7.93069,
    y1: 4.21515,
    x2: 13.6615,
    y2: 4.19844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1612_352",
    x1: 2.35997,
    y1: 8.34983,
    x2: 10.9748,
    y2: 8.32466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0c93ed46eb4fef329dbcb3b7ec562a2f.svg";
export { ForwardRef as ReactComponent };